import React, { useEffect, useState, useMemo } from 'react';
import { ApplicationRoles } from './api-authorization/ApiAuthorizationConstants';

import Button from 'react-bootstrap/Button';
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import Table from "react-bootstrap/Table";
import Badge from "react-bootstrap/Badge"

import authorizeService from './api-authorization/AuthorizeService';

import { Typeahead } from 'react-bootstrap-typeahead';
import 'react-bootstrap-typeahead/css/Typeahead.css';
import fixtureService from '../services/FixtureService';
import teamsService from '../services/TeamsService';
import { Form } from 'react-bootstrap';
import FixtureDetailsModal from './Modals/FixtureDetailsModal';
import DeleteTrainingModal from './Modals/DeleteTrainingModal';
import CompleteTrainingModal from './Modals/CompleteTrainingModal';
import CreateTrainingFixturesModal from './Modals/CreateTrainingFixturesModal';

const TrainingFixtures = (props) => {
    const typeAheadRef = React.createRef();

    const [fixtures, setFixtures] = useState(null);
    const [teamNames, setTeamNames] = useState(null);
    const [search, setSearch] = useState(null);
    const [loading, setLoading] = useState(true);

    const [showFixtureDetailsModal, setShowFixtureDetailsModal] = useState(false);
    const [showDeleteTrainingModal, setShowDeleteTrainingModal] = useState(false);
    const [showCompleteTrainingModal, setShowCompleteTrainingModal] = useState(false);
    const [showTrainingFixturesModal, setShowTrainingFixturesModal] = useState(false);
    const [newTrainingFixtureAdded, setNewTrainingFixtureAdded] = useState(false);
    const [selectedFixture, setSelectedFixture] = useState(null);
    const [selectedFixtureRoomId, setSelectedFixtureRoomId] = useState(null);
    const [selectedFixtureActive, setSelectedFixtureActive] = useState(false);
    const [selectedStatus, setSelectedStatus] = useState('all');
    const [isRoomActive, setIsRoomActive] = useState([]);

    const [userRole, setUserRole] = useState(null);
    const [activeUserId, setActiveUserId] = useState(null);

    const fetchFixtures = async () => {
        fixtureService.getTrainingFixturesList().then((list) => {
            setFixtures(list);
            setIsRoomActive(list.map(x => ({
                fixtureRoomId: x.fixtureRoomId,
                key: x?.endAtString
            })).filter(x => x.key !== null));
        });
    }
    useEffect(() => {
        if (!userRole) {
            authorizeService.getUser().then((user) => {
                setActiveUserId(user.sub);
                setUserRole(user.role);
            })
        }
    }, []);

    useEffect(() => {
        if (!fixtures || newTrainingFixtureAdded || showFixtureDetailsModal) {
            fetchFixtures().then(r => {
                    setLoading(false);
                    setNewTrainingFixtureAdded(false);
                }
            )
        }
    }, [newTrainingFixtureAdded, showFixtureDetailsModal]);

    useEffect(() => {
        if (!teamNames) {
            teamsService.getTeamNames().then((teamNames) => {
                setTeamNames(teamNames);
                setLoading(false);
            });
        }
    }, []);

    const hideTrainingFixturesModal = () => {
        setShowTrainingFixturesModal(false);
    }

    const hideFixtureDetailsModal = () => {
        setShowFixtureDetailsModal(false);
    }
    const hideDeleteTrainingModal = () => {
        setShowDeleteTrainingModal(false);
    }
    const hideCompleteTrainingModal = async () => {
        setShowCompleteTrainingModal(false);
        await fetchFixtures();
    }

    const renderFixtureDetailsModal = () => {
        if (selectedFixture) {
            return <FixtureDetailsModal
                show={showFixtureDetailsModal}
                onHide={hideFixtureDetailsModal}
                userRole={userRole}
                fixture={selectedFixture}>
            </FixtureDetailsModal>;
        } else
            return <></>;
    }
    const renderDeleteTrainingModal = () => {
        if (selectedFixture) {
            return <DeleteTrainingModal
                show={showDeleteTrainingModal}
                onHide={hideDeleteTrainingModal}
                userRole={userRole}
                selectedFixture={selectedFixture}
                fixtures={fixtures}
                setFixtures={setFixtures}
                fixtureRoomId={selectedFixture.fixtureRoomId}>
            </DeleteTrainingModal>;
        } else
            return <></>;
    }
    const renderCompleteTrainingModal = () => {
        if (selectedFixture) {
            return <CompleteTrainingModal
                show={showCompleteTrainingModal}
                onHide={hideCompleteTrainingModal}
                userId={activeUserId}
                bureauMatchId={selectedFixture.bureauMatchId}
                selectedFixtureRoomId={selectedFixtureRoomId}
                setSelectedFixtureActive={setSelectedFixtureActive}
                selectedFixtureActive={selectedFixtureActive}
                isRoomActive={isRoomActive}
                setIsRoomActive={setIsRoomActive}
            >
            </CompleteTrainingModal>;
        } else
            return <></>;
    }
    const renderTrainingFixturesModal = () => {
        if (userRole && userRole == ApplicationRoles.Manager) {
            return <CreateTrainingFixturesModal
                show={showTrainingFixturesModal}
                onHide={hideTrainingFixturesModal}
                setNewTrainingFixtureAdded={setNewTrainingFixtureAdded}
            >
            </CreateTrainingFixturesModal>
        } else
            return <></>
    }

    const renderDropdown = (fixtures, setSearch) => {
        if (fixtures) {
            let typeAheadFixtures = fixtures.map((x) => {
                return {id: x.trainingRoomName, label: x.trainingRoomName}
            });

            return <Typeahead
                id="my-typeahead-id"
                ref={typeAheadRef}
                clearButton
                multiple
                onChange={(selected) => {
                    if (selected && selected.length > 0) {
                        setSearch(selected.map(x => x.id));
                    } else {
                        setSearch(null);
                    }
                }}
                options={typeAheadFixtures}
                placeholder="Type to search training fixtures by training room name"
            />
        }
        return <></>
    }
    const renderDropdownStatus = () => {
        const status = [
            {
                value: 'all',
                label: 'All fixtures',
            },
            {
                value: 'complete',
                label: 'Complete fixtures',
            },
            {
                value: 'incomplete',
                label: 'Incomplete fixtures',
            }
        ]
        return <Form.Control as="select"
                             value={selectedStatus}
                             onChange={(event) => {
                                 setSelectedStatus(event.target.value)
                             }}
                             style={{
                                 width: '220px',
                                 color: '#007bff',
                                 textAlignLast: 'center',
                                 padding: '6px 12px',
                                 borderColor: '#007bff'
                             }}
        >
            <option value={status[0].value} hidden style={{color: 'black'}}>{status[0].label}</option>
            {
                status.map((x, i) => <option value={x.value} key={i} style={{color: 'black'}}>{x.label}</option>)
            }
        </Form.Control>
    }

    const renderTable = (fixtures) => {
        const content = !fixtures || fixtures.length == 0 ? (
            <tr className="p-2">
                <td colSpan="9" className="text-center">No Training Fixtures</td>
            </tr>
        ) : (fixtures.map((x) => {
            return (
                <tr key={x.fixtureId}>
                    <td>
                        <i
                            className="fas fa-fw fa-bullseye"
                            style={{color: "red"}}
                        ></i>
                    </td>
                    <td>
                        {x.trainingRoomName}
                    </td>
                    <td>
                        <Button size="sm"
                                variant="outline-info"
                                className="ml-2"
                                onClick={() => {
                                    setSelectedFixture(x);
                                    setShowFixtureDetailsModal(true);
                                }}>Details</Button>

                        <Button size="sm"
                                variant="outline-danger"
                                className="ml-2"
                                onClick={() => {
                                    setSelectedFixture(x);
                                    setShowDeleteTrainingModal(true);
                                }}>Delete</Button>
                    </td>
                    <td>{x.tags ? x.tags.map(x => <Badge key={x.text} className="ml-1"
                                                         variant={x.variant}>{x.text}</Badge>) : []}</td>
                    <td>
                        <Button
                            key={x.fixtureRoomId}
                            className="ml-1"
                            style={{
                                cursor: 'pointer'
                            }}
                            size="sm"
                            variant={isRoomActive?.filter(y => y.fixtureRoomId === x.fixtureRoomId)[0]?.fixtureRoomId ? 'outline-secondary' : 'outline-primary'}
                            onClick={() => {
                                setSelectedFixture(x);
                                setSelectedFixtureRoomId(x.fixtureRoomId)
                                setShowCompleteTrainingModal(true);
                                setSelectedFixtureActive(!isRoomActive?.filter(y => y.fixtureRoomId === x.fixtureRoomId)[0]?.fixtureRoomId);
                            }}
                        >
                            {isRoomActive?.filter(y => y.fixtureRoomId === x.fixtureRoomId)[0]?.fixtureRoomId ? 'Re-open room' : 'Complete room'}
                        </Button>
                    </td>
                </tr>
            );
        }));

        return (
            <>
                <div style={{
                    overflowY: 'scroll',
                    overflowX: 'scroll',
                    whiteSpace: 'nowrap',
                    maxHeight: 'calc(100vh - 180px)'
                }}>
                    <Table striped bordered hover className="react-bootstrap-table">
                        <thead>
                        <tr>
                            <th></th>
                            <th>
                                Training Room Name
                            </th>
                            <th>Actions</th>
                            <th>Room Status</th>
                            <th>Update Room</th>
                        </tr>
                        </thead>
                        <tbody>
                        {content}
                        </tbody>
                    </Table>
                </div>
            </>
        );
    };

    let getFilteredFixtures = (fixtures, search) => {
        if (fixtures) {
            if (search && search.length > 0) {
                return fixtures.filter(x => {
                    return search.some(y => x.trainingRoomName == y)
                })
            } else {
                return fixtures.filter(x => x.homeTeamName && x.homeTeamName !== '');
            }
        }
    }
    let getFilteredFixturesStatus = (fixtures, selectedStatus) => {
        if (selectedStatus === 'incomplete') return fixtures.filter(x => x.tags.some(tag => tag.text === 'Room Active'));
        if (selectedStatus === 'all') return fixtures;
        if (selectedStatus === 'complete') return fixtures.filter(x => !x.tags.some(tag => tag.text === 'Room Active'));
    }
    const filteredFixtures = useMemo(() => {
        let filteredFixtures = fixtures;
        if (search) filteredFixtures = getFilteredFixtures(filteredFixtures, search);
        if (selectedStatus) filteredFixtures = getFilteredFixturesStatus(filteredFixtures, selectedStatus);

        return filteredFixtures
    }, [fixtures, search, selectedStatus]);

    let title = <h1 id="tabelLabel">Training Fixtures</h1>;

    let contents = loading ? <p><em>Loading...</em></p> : renderTable(filteredFixtures);

    let fixtureDetailsModal = renderFixtureDetailsModal();
    let deleteTrainingModal = renderDeleteTrainingModal();
    let completeTrainingModal = renderCompleteTrainingModal();
    let dropdown = renderDropdown(fixtures, setSearch);
    let dropdownStatus = renderDropdownStatus();

    let createTrainingFixtureModal = renderTrainingFixturesModal();

    return (
        <div>
            {title}

            <Row className="mb-2 mr-0">
                <Col sm="6" lg="4">
                    {dropdown}
                </Col>
                <Col sm="6" lg="8" style={{display: 'flex', gap: 10, justifyContent: 'flex-end'}}>
                    {dropdownStatus}
                    {(userRole && userRole === ApplicationRoles.Manager) &&
                        <Button
                            className="float-right"
                            variant="outline-primary"
                            onClick={async () => {
                                await setShowTrainingFixturesModal(true);
                            }}
                        >Create Training Fixtures</Button>
                    }
                </Col>
            </Row>

            {contents}

            {fixtureDetailsModal}
            {deleteTrainingModal}
            {completeTrainingModal}
            {createTrainingFixtureModal}
        </div>
    );
}

TrainingFixtures.displayName = TrainingFixtures.name;

export default TrainingFixtures;